import {Injectable, OnDestroy} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable, SubscriptionLike} from 'rxjs';
import {filter, tap, withLatestFrom} from 'rxjs/operators';
import {CurrentModule} from '../../models/current-module';
import {selectCurrentContextFeature} from '../../redux/current-context/current-context-selectors';
import {CurrentContextState} from '../../redux/current-context/reducer/current-context.reducer';
import {CurrentContextService} from '../../redux/current-context/service/current-context.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastaService } from 'ngx-toasta';
import { WkfTaskService } from '../workflow/wkf-task-service';
import { WorkflowModelInfosService } from '../../redux/workflow-model-infos/service/workflow-model-infos-service';
import { InternalRoutes } from '../../models/internal-routes';
import { AuthenticationService } from '../../../entry-routes/authentication/authentication.service';
import { SocketService } from '../socket/socket.service';
import { CurrentSupervisionService } from '../../redux/current-supervision/service/current-supervision.service';
import { WkfSupervisionService } from '../workflow/wkfSupervisionService';
import { WkfSupervisionParams } from '../../models/workflow/wkf-supervision-params';


@Injectable({providedIn: 'root'})
export class ModuleFromRouteDefinerService implements OnDestroy {

  currentContext$ = this.store.select(selectCurrentContextFeature);
  private subs: SubscriptionLike[] = [];


  constructor(
    private router: Router,
    private currentContextService: CurrentContextService,
    private store: Store,
    private wkfTaskService: WkfTaskService,
    private translateService: TranslateService,
    private toastaService: ToastaService,
    private workflowModelInfosService: WorkflowModelInfosService,
    private authenticationService: AuthenticationService,
    private socketService: SocketService,
    private currentSupervionService: CurrentSupervisionService,
    private wkfSupervisionService: WkfSupervisionService
  ) {
  }

  ngOnDestroy() {
    this.subs.forEach((subscription) => subscription.unsubscribe());
  }

  public watchAndDefineModuleFromRoute(): Observable<any> {
    return this.router.events.pipe(
      filter((event) => (event instanceof NavigationEnd)),
      withLatestFrom(this.currentContext$),
      tap(([ , currentContextState]) => {
          if (!this.router.url.includes(InternalRoutes.DELEGATIONS_MANAGEMENT)) {
                this.setCurrentModule(currentContextState);
          }
      }));
  }

  private setCurrentModule(currentContextState: CurrentContextState): void {
    let isWorkflow = false;
    if (this.router.url.indexOf(CurrentModule.WORKFLOW) !== -1) {
      isWorkflow = true;
    }
    if (isWorkflow) {
      if (!currentContextState || !currentContextState.datas || currentContextState.datas.currentModule !== CurrentModule.WORKFLOW) {
        this.currentContextService.setCurrentModule(CurrentModule.WORKFLOW);

        const currentTaskMatTableColumnDefs = this.currentContextService.getCurrentTaskMatTableColumnDefs();
        if (!currentTaskMatTableColumnDefs || currentTaskMatTableColumnDefs.domain !== this.currentContextService.getCurrentDomain()) {
            const taskMatTableColumnDefs$=this.wkfTaskService.getTaskMatTableColumnDefs(this.currentContextService.getCurrentDomain());
            taskMatTableColumnDefs$.subscribe( {
              next: (displayedColumnsDef)=> {
                this.currentContextService.setCurrentTaskMatTableColumnDef(displayedColumnsDef);
              },
              error: (error) => {
                console.error('setCurrentModule() erreur lors de la récupération de config des colonnes', error);
                this.currentContextService.setCurrentTaskMatTableColumnDef(null);
              }
            });
        }

        const currentWkfSupervisionParams = this.currentSupervionService.getCurrentWkfSupervisionParams();
        if ( !currentWkfSupervisionParams || currentWkfSupervisionParams.domainCode !== this.currentContextService.getCurrentDomain() ) {
            const currentWkfSupervisionParams$ = this.wkfSupervisionService.getWkfSupervisionParams(this.currentContextService.getCurrentDomain());
            currentWkfSupervisionParams$.subscribe( {
                next:(wkfSupervisionParams : WkfSupervisionParams)=> {
                    this.currentSupervionService.setCurrentWkfSupervisionParams(wkfSupervisionParams);
                },
                error: (error) => {
                    console.error('setCurrentModule() erreur lors de la récupération du parametrage supervision', error);
                }
            });
        }
      }

      this.workflowModelInfosService.loadWorkflowModelInfos();

    } else {

      if(!!this.authenticationService.currentDelegant) {
          this.socketService.leaveUser(this.authenticationService.currentDelegant.id.toString());
          this.socketService.joinUser(this.authenticationService.getUserCredentials().id.toString());
          this.authenticationService.removeDelegantSucceeded();
      }
      if (!currentContextState || !currentContextState.datas || currentContextState.datas.currentModule !== CurrentModule.GED) {
        this.currentContextService.setCurrentModule(CurrentModule.GED);
      }
    }
  }

}
